import config from '../../../../config'

export const hasAccessRightsToDistraints = (state) =>
    state.getIn(['authorization', 'accessRights', config.modules.distraints.key, 'hasRights'])
